module.exports = __webpack_public_path__ + "img/Bank-128.fbf0101a.png";